"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = formatDate;
exports.addDays = addDays;
const date_fns_1 = require("date-fns");
/**
 *
 * @param date
 * @param format Pattern reference: https://date-fns.org/v2.28.0/docs/format BUT stick with Unicode Technical Standard 35: https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @returns
 */
function formatDate(date, format) {
    const formattedDate = (0, date_fns_1.format)(date, format);
    return formattedDate;
}
function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}
